import React from 'react'
import Img from 'gatsby-image'
import styles from './index.module.css'
import { relative } from 'path'

const Gallery = data => (
  <div className={styles.wrapper}>
    {data.sizes.map((loop, index) => (
      <Img
        key={index}
        outerWrapperClassName={'gallery'}
        style={{ maxWidth: '90vw', width: 'auto', height: 'auto', maxHeight: '90vh' }}
        imgStyle={{ left: '50%', marginRight: '-50%', transform: 'translate(-50%)', maxHeight: '90vh', maxWidth: '90vw', width: 'auto', height: 'auto' }}
        sizes={loop.node.childImageSharp.sizes}
      />
    ))}
  </div>
)

export default Gallery



// WEBPACK FOOTER //
// ./src/components/Gallery/index.js